<template>
  <li :class="[$style['tree-node'], active ? $style['tree-node--active'] : null]">
    <template v-if="item.children">
      <div :aria-expanded="groupOpen" :class="$style['tree-node--group']">
        <v-icon :class="[$style.icon]" @click="groupOpen = !groupOpen">
          {{ groupOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
        <span @click="groupOpen = !groupOpen">{{ item.name }}</span>
      </div>
      <ul v-show="groupOpen" :class="$style['tree-group']">
        <TreeViewItem v-for="child in item.children" :key="child.id" :item="child" :color="color" />
      </ul>
    </template>

    <BaseCheckbox
      v-else
      :key="item.id"
      :input-value="item.id"
      :color="color"
      :label="item.name"
      @input="changeState(item)"
    />
  </li>
</template>

<script>
import { mapMutations } from 'vuex'
import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_MUTATION from '@/js/components/Forms/ComplaintForm/_store-module/mutation-types.js'

export default {
  name: 'TreeViewItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
      groupOpen: false,
    }
  },
  methods: {
    ...mapMutations(FORM_CONSTANTS.STORE_ID, {
      setCheckboxSelections: FORM_MUTATION.SET_CHECKBOX_SELECTIONS,
      removeCheckboxSelection: FORM_MUTATION.REMOVE_CHECKBOX_SELECTION,
    }),
    changeState(item) {
      this.active = !this.active
      this.setSelected({ item, active: this.active })
    },
    setSelected(sparePart) {
      if (!sparePart.active) {
        this.removeCheckboxSelection(sparePart.item)
      } else {
        this.setCheckboxSelections(sparePart.item)
      }
    },
  },
}
</script>

<style lang="scss" module>
.tree-node {
  padding-left: 2rem !important;

  label {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      margin-left: 1rem !important;

      font-size: var(--font-base);
    }
    margin-left: 0 !important;

    font-size: var(--font-sm);
  }

  .tree-group {
    padding-left: 0 !important;
  }

  .icon {
    position: absolute;
    top: 50%;
    left: -1.5rem;

    transform: rotate(0deg) translateY(-50%);

    transition: 0.2s transform ease-in;

    &--open {
      top: 15%;

      transform: rotate(180deg);
    }
  }

  :global(.v-messages) {
    display: none;
  }

  :global(.v-input--selection-controls) {
    margin-top: 0;
  }

  &--group {
    position: relative;

    span {
      @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
        font-size: var(--font-base);
      }
      font-size: var(--font-sm);

      cursor: pointer;
    }
  }

  &--active {
  }

  &--disabled {
    background-color: var(--grey-lighten-1);

    pointer-events: none;

    :global(.theme--light.v-label),
    span {
      color: var(--grey) !important;
    }
  }
}
</style>
